import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';

@Component({
    selector: 'app-toggle',
    templateUrl: './toggle.component.html',
    styleUrl: './toggle.component.scss',
})
export class ToggleComponent implements OnInit, OnChanges {
    @Input() label: string | null = null;
    @Input() initialToggled: boolean = false;
    @Input() dataQa = '';
    @Output() toggledTo = new EventEmitter<boolean>();

    toggled: boolean = false;

    ngOnInit() {
        this.toggled = this.initialToggled;
    }

    ngOnChanges(changes: SimpleChanges): void {
        const toggleChange = changes['initialToggled'];
        if (toggleChange && !toggleChange.firstChange) {
            this.toggled = toggleChange.currentValue;
        }
    }

    onToggle(e: Event) {
        this.toggledTo.emit((e.target as HTMLInputElement).checked);
    }
}
